import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';

import { BookingStore, BookingSubscription, BOOKING_TRIAL_SUBSCRIPTIONS_FILTER_TYPE } from '@store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-booking-extend-trial-list',
  templateUrl: './booking-extend-trial-list.component.html',
  styleUrls: ['./booking-extend-trial-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingExtendTrialListComponent implements OnInit, OnChanges {
  readonly filterType = BOOKING_TRIAL_SUBSCRIPTIONS_FILTER_TYPE;
  @Input() searchTerm: string;

  currentFilter: BOOKING_TRIAL_SUBSCRIPTIONS_FILTER_TYPE = this.filterType.ALL;

  trialSubscriptionsActiveOnlineOnly: BookingSubscription[];
  trialActiveSubscriptionsOfflineForBooking: BookingSubscription[];
  trialSubscriptionsActive: BookingSubscription[];

  trialSubscriptions: BookingSubscription[];

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(public bookingStore: BookingStore, public router: Router) {}

  ngOnInit(): void {
    this.bookingStore.trialSubscriptionsActiveOnlineOnly$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((sub) => (this.trialSubscriptionsActiveOnlineOnly = sub));

    this.bookingStore.trialActiveSubscriptionsOfflineForBooking$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((sub) => (this.trialActiveSubscriptionsOfflineForBooking = sub));

    this.bookingStore.trialSubscriptionsActive$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((sub) => (this.trialSubscriptionsActive = sub));

    this.setInstallationsToDisplay();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const searchTermChanged =
      changes?.searchTerm?.currentValue !== changes?.searchTerm?.previousValue;

    if (searchTermChanged) {
      this.setInstallationsToDisplay();
    }
  }

  setFilter(filterType: BOOKING_TRIAL_SUBSCRIPTIONS_FILTER_TYPE): void {
    this.currentFilter = filterType;
    this.setInstallationsToDisplay();
  }

  onExtendAll(): void {
    this.router.navigate(['/booking-extend-trial']);
  }

  private setInstallationsToDisplay(): void {
    switch (this.currentFilter) {
      case BOOKING_TRIAL_SUBSCRIPTIONS_FILTER_TYPE.ALL:
        this.trialSubscriptions = this.trialSubscriptionsActive;
        break;

      case BOOKING_TRIAL_SUBSCRIPTIONS_FILTER_TYPE.OFFLINE:
        this.trialSubscriptions = this.trialActiveSubscriptionsOfflineForBooking;
        break;

      case BOOKING_TRIAL_SUBSCRIPTIONS_FILTER_TYPE.ONLINE:
      default:
        this.trialSubscriptions = this.trialSubscriptionsActiveOnlineOnly;
    }

    if (!this.searchTerm) {
      return;
    }
    const filterString = this.searchTerm.toLowerCase();

    this.trialSubscriptions = this.trialSubscriptions.filter((subscription) => {
      return (
        subscription.subscribedBy?.toLowerCase().includes(filterString) ||
        subscription.boilerId?.toLowerCase().includes(filterString) ||
        subscription.ownerName?.toLowerCase().includes(filterString) ||
        subscription.subscribedByName?.toLowerCase().includes(filterString) ||
        subscription.marketingName?.toLowerCase().includes(filterString)
      );
    });
  }
}
